import { useState, useEffect } from "react";

import { setValue, getValue } from "@/utils/storage";
import { getServiceStatus } from "@/services/api";
import LiveKitProvider from "@/providers/LiveKitProvider";
import { useGlobalState } from "@/hooks";
import Step1 from "./step1";
import Step2 from "./step2";
import StepAgentClosed from "./stepAgentClosed";
import { AgentTimeoutProvider } from "./providers/AgentTimeoutProvider";

const AGENT_OPEN_TIMEOUT = 30 * 60 * 1000;

const App = ({ storeUrl }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [isServiceActive, setServiceStatus] = useState(false);
  const { connect, setShowReconnectPrompt, setStoreUrl, setCustomerId } =
    useGlobalState();

  useEffect(() => {
    const existingId = getValue("customer_id");

    if (!existingId || existingId === "null") {
      const randomId = Math.floor(Math.random() * 1000000).toString();

      setValue("customer_id", randomId);
      setCustomerId(randomId);
    } else {
      setCustomerId(existingId);
    }

    setStoreUrl(storeUrl);
  }, [storeUrl, setStoreUrl, setCustomerId]);

  useEffect(() => {
    const check = async () => {
      const status = await getServiceStatus(storeUrl);

      setServiceStatus(status);
    };

    check();

    if (currentStep === 0) {
      setCurrentStep(getDefaultStep());
    }
  }, []);

  useEffect(() => {
    if (currentStep === 2) {
      connect();
    }
  }, [currentStep]);

  if (!isServiceActive) {
    return null;
  }

  if (currentStep === 0) {
    return <StepAgentClosed setStep={setCurrentStep} />;
  }

  return (
    <LiveKitProvider>
      <AgentTimeoutProvider onTimeout={() => setShowReconnectPrompt(true)}>
        {currentStep === 1 ? (
          <Step1 setStep={setCurrentStep} />
        ) : currentStep === 2 ? (
          <Step2 setStep={setCurrentStep} />
        ) : null}
      </AgentTimeoutProvider>
    </LiveKitProvider>
  );
};

export default App;

const getDefaultStep = () => {
  const lastInteraction = Number(getValue("last_interaction"));
  const lastVisit = Number(getValue("last_visit"));

  const mostRecentActivity = Math.max(lastInteraction, lastVisit);
  setValue("last_visit", Date.now().toString());

  // Default agent to open if last interaction was more than timeout
  if (
    !mostRecentActivity ||
    Date.now() - mostRecentActivity > AGENT_OPEN_TIMEOUT
  ) {
    return 1;
  }

  return 0;
};
